import CertificateList from "./CertificateList";

export default CertificateList;